export default {
  instanceContract: 'contract',
  instanceForm: 'form',
}
